<template>
  <!-- 新建派送费 -->
  <div class="jy-main-list">
    <div class="jy-main-list-table">
      <div class="button-ground">
        <el-button
            @click="onNextPage"
            plain
            class="jy-button"
            v-if="activeName == 'first'"
        >下一步</el-button
        >
        <el-button
            @click="onNextPage"
            plain
            class="jy-button"
            v-if="activeName == 'second'"
        >下一步</el-button
        >
        <el-button
            @click="onPreviousPage"
            plain
            class="jy-button"
            v-if="activeName == 'second'"
        >返回上一步</el-button
        >
        <el-button
            @click="onNextPage"
            plain
            class="jy-button"
            v-if="activeName == 'third'"
        >下一步</el-button
        >
        <el-button
            @click="onPreviousPage"
            plain
            class="jy-button"
            v-if="activeName == 'third'"
        >返回上一步</el-button
        >
        <el-button
            @click="onSave"
            plain
            class="jy-button"
            v-if="activeName == 'fourth'"
        >保存</el-button
        >
        <el-button
            @click="onPreviousPage"
            plain
            class="jy-button"
            v-if="activeName == 'fourth'"
        >返回上一步</el-button
        >
      </div>

      <div class="table-ground">
        <div class="contentInner">
          <div class="jy-form-container jy-common-el-tab" style="width: 100%">
            <el-tabs type="border-card" stretch v-model="activeName">
              <el-tab-pane
                  label="基本信息"
                  name="first"
                  :disabled="activeName != 'first'"
              >
                <div class="jy-line-container">
                  <el-form
                      :model="baseInfoForm"
                      label-width="220px"
                      label-position="right"
                  >
                    <el-row :gutter="gutter">
                      <el-col :span="span">
                        <el-form-item
                            label="派送费类型："
                            class="jy-form-input"
                            :rules="[{ required: true, message: '必填' }]"
                        >
                          <el-select
                              v-model="baseInfoForm.isMain"
                              placeholder="是否主报价"
                          >
                            <el-option label="主派送费" value="1" />
                            <el-option label="附加派送费" value="0" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="span">
                        <el-form-item
                            label="归属主线路："
                            class="jy-form-input"
                        >
                          <el-select
                              v-model="baseInfoForm.parentId"
                              @visible-change="visibleChange($event, 11)"
                              @change="changePCName"
                              clearable
                          >
                            <!-- @change="
                              onSelect(
                                $event,
                                parentChannelOptions,
                                ['parentId', ''],
                                ['id', 'channelName']
                              )
                            " -->
                            <el-option
                                v-for="(item, index) in parentChannelOptions"
                                :key="index"
                                :label="item.channelName"
                                :value="item.id"
                            />
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="gutter">
                      <el-col :span="span">
                        <el-form-item label="线路编号：" class="jy-form-input">
                          <el-input v-model="baseInfoForm.number"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="span">
                        <el-form-item
                            label="线路名称："
                            class="jy-form-select"
                            :rules="[{ required: true, message: '必填' }]"
                        >
                          <el-input
                              v-model="baseInfoForm.channelName"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="span">
                        <el-form-item
                            label="末端派送："
                            class="jy-form-select"
                            :rules="[{ required: true, message: '必填' }]"
                        >
                          <el-select
                              v-model="baseInfoForm.handoverMode"
                              @visible-change="visibleChange($event, 1)"
                              @change="
                              onSelect(
                                $event,
                                handoverModeOptions,
                                [
                                  'handoverModeConfDictId',
                                  'handoverMode',
                                ],
                                ['confDictId', 'val']
                              )
                            "
                              clearable
                          >
                            <el-option
                                v-for="(item, index) in handoverModeOptions"
                                :key="index"
                                :label="item.val"
                                :value="item.confDictId"
                            />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="span">
                        <el-form-item
                            label="客户等级："
                            class="jy-form-select"
                            :rules="[{ required: true, message: '必填' }]"
                        >
                          <el-select
                              clearable
                              filterable
                              v-model="baseInfoForm.memberLevelName"
                              placeholder="请选择"
                              @visible-change="visibleChange($event, 6)"
                              @change="
                              onSelect(
                                $event,
                                memberlevelDownListOpts,
                                ['confMemberlevelId', 'memberLevelName'],
                                ['id', 'levelName']
                              )
                            "
                          >
                            <el-option
                                v-for="(item, index) in memberlevelDownListOpts"
                                :key="index"
                                :label="item.levelName"
                                :value="item.id"
                            />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <!--                      <el-col :span="span">-->
                      <!--                        <el-form-item-->
                      <!--                            label="币种："-->
                      <!--                            class="jy-form-input"-->
                      <!--                            :rules="[{ required: true, message: '必填' }]"-->
                      <!--                        >-->
                      <!--                          <el-select-->
                      <!--                              clearable-->
                      <!--                              v-model="baseInfoForm.currency"-->
                      <!--                              placeholder="请选择"-->
                      <!--                              @visible-change="visibleChange($event, 7)"-->
                      <!--                              @change="selectCurrency"-->
                      <!--                          >-->
                      <!--                            <el-option-->
                      <!--                                v-for="(item, index) in currencyOptions"-->
                      <!--                                :key="index"-->
                      <!--                                :label="item.cnName"-->
                      <!--                                :value="item.cnName"-->
                      <!--                            />-->
                      <!--                          </el-select>-->
                      <!--                        </el-form-item>-->
                      <!--                      </el-col>-->

                      <!--                      <el-col :span="span">-->
                      <!--                        <el-form-item-->
                      <!--                            label="最低消费："-->
                      <!--                            class="jy-form-input"-->
                      <!--                            :rules="[{ required: true, message: '必填' }]"-->
                      <!--                        >-->
                      <!--                          <el-input-->
                      <!--                              type="number"-->
                      <!--                              v-model="baseInfoForm.minConsume"-->
                      <!--                          ></el-input>-->
                      <!--                        </el-form-item>-->
                      <!--                      </el-col>-->

                      <el-col :span="span">
                        <el-form-item label="派送天数：" class="jy-form-select">
                          <el-input
                              type="number"
                              v-model="baseInfoForm.dispatchDays"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="gutter">
                      <el-col :span="span">
                        <el-form-item
                            label="重量体积系数："
                            class="jy-form-input"
                            :rules="[{ required: true, message: '必填' }]"
                        >
                          <el-input
                              type="number"
                              v-model="baseInfoForm.channelDivisorWeight"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="span">
                        <el-form-item
                            label="体积重量系数："
                            class="jy-form-input"
                            :rules="[{ required: true, message: '必填' }]"
                        >
                          <el-input
                              type="number"
                              v-model="baseInfoForm.channelDivisor"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="gutter">
                      <el-col :span="span">
                        <el-form-item
                            label="重泡计算公式："
                            class="jy-form-select"
                            :rules="[{ required: true, message: '必填' }]"
                        >
                          <el-select
                              clearable
                              v-model="baseInfoForm.formulaBigGoodsName"
                              placeholder="请选择"
                              @visible-change="visibleChange($event, 4)"
                              @change="
                              onSelect(
                                $event,
                                formulaBigGoodDownOptions,
                                ['formulaBigGoodsId', 'formulaBigGoodsName'],
                                ['id', 'name']
                              )
                            "
                          >
                            <el-option
                                v-for="(item, index) in formulaBigGoodDownOptions"
                                :key="index"
                                :label="item.name"
                                :value="item.id"
                            />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="span">
                        <el-form-item
                            label="重泡系数："
                            class="jy-form-input"
                            :rules="[{ required: true, message: '必填' }]"
                        >
                          <el-input
                              type="number"
                              v-model="baseInfoForm.bigGoodsStartWeight"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="gutter">
                      <el-col :span="span">
                        <el-form-item
                            label="计费重量进位规则："
                            class="jy-form-select"
                            :rules="[{ required: true, message: '必填' }]"
                        >
                          <el-select
                              clearable
                              v-model="baseInfoForm.formulaBillWeightCarryName"
                              placeholder="请选择"
                              @visible-change="visibleChange($event, 5)"
                              @change="
                              onSelect(
                                $event,
                                formulaBillingWeightCarryDownOptions,
                                [
                                  'formulaBillingWeightCarryId',
                                  'formulaBillWeightCarryName',
                                ],
                                ['id', 'name']
                              )
                            "
                          >
                            <el-option
                                v-for="(
                                item, index
                              ) in formulaBillingWeightCarryDownOptions"
                                :key="index"
                                :label="item.name"
                                :value="item.id"
                            />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="span">
                        <el-form-item
                            label="计费区段取值规则："
                            class="jy-form-select"
                            :rules="[{ required: true, message: '必填' }]"
                        >
                          <el-select
                              v-model="baseInfoForm.formulaBillingWeightName"
                              placeholder="请选择"
                              clearable
                              @visible-change="visibleChange($event, 10)"
                              @change="
                              onSelect(
                                $event,
                                formulaBillingWeighOptions,
                                [
                                  'formulaBillingWeightId',
                                  'formulaBillingWeightName',
                                ],
                                ['id', 'name']
                              )
                            "
                          >
                            <el-option
                                v-for="(
                                item, index
                              ) in formulaBillingWeighOptions"
                                :key="index"
                                :label="item.name"
                                :value="item.id"
                            />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="span">
                        <el-form-item label="排序：" class="jy-form-input">
                          <el-input
                              type="number"
                              v-model="baseInfoForm.sort"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="gutter">
                      <el-col :span="24">
                        <el-form-item label="派送仓库：" class="jy-form-select">
                          <el-checkbox-group
                              v-model="baseInfoForm.dispatchDeptIds"
                          >
                            <el-checkbox
                                v-for="(value, key) in buMenData"
                                :key="key"
                                :label="value.storageId"
                            >
                              {{ value.storageName }}
                            </el-checkbox>
                          </el-checkbox-group>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="gutter">
                      <el-col :span="span">
                        <el-form-item
                            label="启用日期："
                            class="jy-form-input"
                            :rules="[{ required: true, message: '必填' }]"
                        >
                          <el-date-picker
                              v-model="baseInfoForm.effectiveStartTime"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              type="datetime"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="span">
                        <el-form-item
                            label="截止日期："
                            class="jy-form-input"
                            :rules="[{ required: true, message: '必填' }]"
                        >
                          <el-date-picker
                              v-model="baseInfoForm.effectiveEndTime"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              type="datetime"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item label="备注：" class="jy-form-input">
                          <el-input v-model="baseInfoForm.comment"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </el-tab-pane>
              <el-tab-pane
                  label="维护地区"
                  :disabled="activeName != 'second'"
                  name="second"
              >
                <el-table
                    :data="areaList"
                    element-loading-text="加载中"
                    border=""
                    fit
                    highlight-current-row
                >
                  <el-table-column label="国家" align="center">
                    <template #default="scope">
                      <div v-if="noEdit">{{ scope.row.areaCountryName }}</div>
                      <el-input
                          v-else
                          v-model="scope.row.areaCountryName"
                          size="small"
                          class="order-input"
                          autocomplete="off"
                          @paste.native="pastingArea($event, 'areaCountryName')"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column label="州省" align="center">
                    <template #default="scope">
                      <div v-if="noEdit">{{ scope.row.provinceName }}</div>
                      <el-input
                          v-else
                          v-model="scope.row.provinceName"
                          size="small"
                          class="order-input"
                          autocomplete="off"
                          @paste.native="pastingArea($event, 'provinceName')"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column label="城市" align="center">
                    <template #default="scope">
                      <div v-if="noEdit">{{ scope.row.cityName }}</div>
                      <el-input
                          v-else
                          v-model="scope.row.cityName"
                          size="small"
                          class="order-input"
                          autocomplete="off"
                          @paste.native="pastingArea($event, 'cityName')"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column label="城市邮编" align="center">
                    <template #default="scope">
                      <div v-if="noEdit">{{ scope.row.adcode }}</div>
                      <el-input
                          v-else
                          v-model="scope.row.adcode"
                          size="small"
                          class="order-input"
                          autocomplete="off"
                          @paste.native="pastingArea($event, 'adcode')"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column label="公里数" align="center">
                    <template #default="scope">
                      <div v-if="noEdit">{{ scope.row.mileage }}</div>
                      <el-input
                          v-else
                          v-model="scope.row.mileage"
                          size="small"
                          class="order-input"
                          autocomplete="off"
                          @blur="blurFn"
                          @paste.native="pastingArea($event, 'mileage')"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                      class="operate"
                      align="center"
                      label="操作"
                      fixed="right"
                      width="100"
                  >
                    <template #default="scope">
                      <div class="opt-flex-box">
                        <i
                            class="el-icon-circle-plus"
                            style="font-size: 26px; cursor: pointer; margin-right: 10px;"
                            v-if="areaList.length == scope.$index + 1"
                            @click="onAddAreaInfo(scope.$index)"
                        ></i>
                        <el-popconfirm
                            v-if="areaList.length > 1"
                            title="确定删除该信息吗？"
                            @confirm="onDelAreaList(scope.$index, scope.row)"
                        >
                          <template slot="reference">
                            <i class="el-icon-remove" style="font-size: 26px; cursor: pointer;"></i>
                          </template>
                        </el-popconfirm>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane
                  label="维护价格"
                  name="third"
                  :disabled="activeName != 'third'"
              >
                <el-table
                    :data="priceTable"
                    element-loading-text="加载中"
                    border=""
                    fit
                    highlight-current-row
                >
                  <el-table-column
                      v-for="(item, index) in priceList"
                      :label="item.name"
                      :key="index"
                      align="center"
                  >
                    <template #default="scope">
                      <div v-if="noEdit">{{ scope.row[item.key] }}</div>
                      <el-input
                          v-else
                          v-model="scope.row[item.key]"
                          size="small"
                          class="order-input"
                          autocomplete="off"
                          @paste.native="pastingPrice($event, item.key)"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                      class="operate"
                      align="center"
                      label="操作"
                      fixed="right"
                      width="100"
                  >
                    <template #default="scope">
                      <div class="opt-flex-box">
                        <i
                            class="el-icon-circle-plus"
                            style="font-size: 26px; cursor: pointer; margin-right: 10px;"
                            v-if="priceTable.length == scope.$index + 1"
                            @click="onAddPriceInfo(scope.$index)"
                        ></i>
                        <el-popconfirm
                            v-if="priceTable.length > 1"
                            title="确定删除该信息吗？"
                            @confirm="onDelPriceList(scope.$index, scope.row)"
                        >
                          <template slot="reference">
                            <i class="el-icon-remove" style="font-size: 26px; cursor: pointer;"></i>
                          </template>
                        </el-popconfirm>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane
                  label="编辑派送费"
                  name="fourth"
                  :disabled="activeName != 'fourth'"
              >
                <el-table
                    :data="deliveryFeeTable"
                    element-loading-text="加载中"
                    border=""
                    fit
                    highlight-current-row
                >
                  <el-table-column
                      v-for="(item, index) in deliveryFeeList"
                      :label="item.name"
                      :width="item.width"
                      :key="index"
                      align="center"
                  >
                    <template #default="scope">
                      <el-select
                          v-if="item.key == 'channelOfferFormulaId'"
                          clearable
                          v-model="scope.row[item.key]"
                          placeholder="请选择"
                          @visible-change="visibleChange($event, 8)"
                          @change="
                          onSelectDetail(
                            $event,
                            channelOfferFormulaDownListOptions,
                            [
                              'channelOfferFormulaId',
                              'channelOfferFormulaName',
                            ],
                            ['id', 'formulaName'],
                            scope.$index
                          )
                        "
                      >
                        <el-option
                            v-for="(
                            item, index
                          ) in channelOfferFormulaDownListOptions"
                            :key="index"
                            :label="item.formulaName"
                            :value="item.id"
                        />
                      </el-select>
                      <el-input
                          v-else
                          :disabled="item.disabled"
                          v-model="scope.row[item.key]"
                          size="small"
                          class="order-input"
                          autocomplete="off"
                          @paste.native="pastingDeliveryFee($event, item.key)"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                      class="operate"
                      align="center"
                      label="操作"
                      fixed="right"
                      width="100"
                  >
                    <template #default="scope">
                      <div class="opt-flex-box">
                        <i
                            class="el-icon-circle-plus"
                            style="font-size: 26px; cursor: pointer; margin-right: 10px;"
                            v-if="deliveryFeeTable.length == scope.$index + 1"
                            @click="onAddDeliveryFeeInfo(scope.$index)"
                        ></i>
                        <el-popconfirm
                            v-if="deliveryFeeTable.length > 1"
                            title="确定删除该信息吗？"
                            @confirm="
                            onDelDeliveryFeeList(scope.$index, scope.row)
                          "
                        >
                          <template slot="reference">
                            <i class="el-icon-remove" style="font-size: 26px; cursor: pointer;"></i>
                          </template>
                        </el-popconfirm>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "@/assets/js/api";
import utils from "@/assets/js/tool";
import { Message as ElMessage, MessageBox as ElMessageBox } from 'element-ui'
import bus from "@/assets/js/tool";

export default {
  name: "DeliveryFeeCreation",
  data() {
    return {
      gutter: 12,
      span: 6,
      // 根据分辨率 调整表单宽度
      noEdit: false,
      areaListBackup: [
        {
          areaCountryName: "",
          provinceName: "",
          cityName: "",
          adcode: "",
          mileage: "",
        },
      ],
      areaList: [
        {
          areaCountryName: "",
          provinceName: "",
          cityName: "",
          adcode: "",
          mileage: "",
        },
      ],
      mainID: "",
      activeName: "first",
      activeNameArray: ["first", "second", "third", "fourth"],
      adcodeArray: [],
      baseInfoForm: {
        parentId: 0,
        isMain: "",
        bigGoodsStartWeight: "",
        channelDivisor: "",
        channelDivisorId: 0,
        channelDivisorWeight: "",
        channelDivisorWeightId: 0,
        channelId: 0,
        channelName: "",
        number: "",
        comment: "",
        confMemberlevelId: "",
        createTime: "",
        createUserName: "",
        currency: "",
        currencyId: 0,
        // minConsume: 0.00,
        dispatchDays: "",
        dispatchDeptList: [],
        dispatchDeptIds: [],
        effectiveEndTime: "",
        effectiveStartTime: "",
        formulaBigGoodsId: 0,
        formulaBigGoodsName: "",
        formulaBillWeightCarryName: "",
        formulaBillingWeightCarryId: 0,
        formulaBillingWeightId: 0,
        formulaBillingWeightName: "",
        memberLevelName: "",
        sort: 0,
        handoverMode: "",
        handoverModeConfDictId: 0,
        updateTime: "",
        updateUserName: "",
      },
      // 备份基本信息
      backupsBaseInfoForm: {},
      parentChannelOptions: [],
      handoverModeOptions: [],
      areaCountryOptions: [],
      formulaDownOptions: [],
      formulaBigGoodDownOptions: [],
      formulaBillingWeightCarryDownOptions: [],
      memberlevelDownListOpts: [],
      currencyOptions: [],
      channelOfferFormulaDownListOptions: [],
      waybillTypeOptions: [],
      formulaBillingWeighOptions: [], // 计费区段取值规则
      buMenData: [],
      // 维护价格
      priceListArray: [
        {
          key: "weight",
          name: "重量区间",
        },
        {
          key: "volume",
          name: "体积区间",
        },
      ],
      priceList: [],
      priceTable: [],
      pastePrice: "",
      // 编辑派送费
      deliveryFeeArray: [
        {
          key: "volume",
          name: "体积区间段",
          width: "100",
        },
        {
          key: "startVolume",
          name: "最低体积",
          width: "100",
          // disabled:true
        },
        {
          key: "endVolume",
          name: "最高体积",
          width: "100",
          // disabled:true
        },
        {
          key: "weight",
          name: "重量区间段",
          width: "100",
        },
        {
          key: "startWeight",
          name: "最低重量",
          width: "100",
          // disabled:true
        },
        {
          key: "endWeight",
          name: "最高重量",
          width: "100",
          // disabled:true
        },
        {
          key: "channelOfferFormulaId",
          name: "计费方式",
          width: "100",
        },
        {
          key: "unitWeight",
          name: "单位体积",
          width: "100",
        },
      ],
      deliveryFeeList: [],
      deliveryFeeTable: [],
    };
  },
  mounted() {
    this.windowResize();
    window.onresize = () => {
      this.windowResize();
    };
    this.getBuMenData();
    this.backupsBaseInfoForm = utils.relObjRam(this.baseInfoForm);
    this.initData();
  },
  watch: {
    $route: {
      handler(newVal) {
        const query = newVal.query;
        const meta = newVal.meta;
        if (meta.china == "派送费新建") {
          if (query && query.id) {
            this.offerBaseDetail(query.id);
          } else {
            if (meta.cache == "false") {
              utils.oldObjToNewObj(this.baseInfoForm, this.backupsBaseInfoForm);
            }
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    // 根据分辨率 调整表单宽度
    windowResize() {
      let clientWidth = document.body.clientWidth;
      if (clientWidth <= 1760) {
        this.span = 8;
      } else {
        this.span = 8;
      }
    },
    initData() {
      this.priceList = [...this.priceListArray];
      this.deliveryFeeList = [...this.deliveryFeeArray];
    },
    onNextPage() {
      if (this.activeName == "first") {
        if (!this.baseInfoForm.isMain) {
          ElMessage({
            message: "派送费类型必填",
            type: "error",
          });
          return false;
        }
        if (!this.baseInfoForm.channelName) {
          ElMessage({
            message: "线路名称必填",
            type: "error",
          });
          return false;
        }
        if (!this.baseInfoForm.handoverMode) {
          ElMessage({
            message: "末端派送必填",
            type: "error",
          });
          return false;
        }
        if (!this.baseInfoForm.confMemberlevelId) {
          ElMessage({
            message: "客户等级必填",
            type: "error",
          });
          return false;
        }
        // if (!this.baseInfoForm.currency) {
        //   ElMessage({
        //     message: "币种必填",
        //     type: "error",
        //   });
        //   return false;
        // }
        if (!this.baseInfoForm.channelDivisorWeight) {
          ElMessage({
            message: "重量体积系数必填",
            type: "error",
          });
          return false;
        }
        if (!this.baseInfoForm.channelDivisor) {
          ElMessage({
            message: "体积重量系数必填",
            type: "error",
          });
          return false;
        }
        if (!this.baseInfoForm.formulaBigGoodsId) {
          ElMessage({
            message: "重泡计算公式必填",
            type: "error",
          });
          return false;
        }
        if (!this.baseInfoForm.bigGoodsStartWeight) {
          ElMessage({
            message: "重泡系数必填",
            type: "error",
          });
          return false;
        }
        if (!this.baseInfoForm.formulaBillingWeightCarryId) {
          ElMessage({
            message: "计费重量进位规则必填",
            type: "error",
          });
          return false;
        }
        if (!this.baseInfoForm.formulaBillingWeightId) {
          ElMessage({
            message: "计费区段取值规则必填",
            type: "error",
          });
          return false;
        }
        if (!this.baseInfoForm.effectiveStartTime) {
          ElMessage({
            message: "启用日期必填",
            type: "error",
          });
          return false;
        }
        if (!this.baseInfoForm.effectiveEndTime) {
          ElMessage({
            message: "截止日期必填",
            type: "error",
          });
          return false;
        }
        const submitObj = {
          parentId: "",
          isMain: "",
          bigGoodsStartWeight: "",
          channelDivisor: "",
          channelDivisorId: "",
          channelDivisorWeight: "",
          channelDivisorWeightId: "",
          channelName: "",
          comment: "",
          confMemberlevelId: "",
          currency: "",
          currencyId: "",
          // minConsume: 0.00,
          dispatchDays: "",
          dispatchDeptIds: [],
          effectiveEndTime: "",
          effectiveStartTime: "",
          formulaBigGoodsId: "",
          formulaBillingWeightCarryId: "",
          formulaBillingWeightId: "",
          number: "",
          sort: 0,
          handoverModeConfDictId: "",
          handoverMode: "",
        };
        // submitObj.bigGoodsStartWeight = "" + baseInfoForm.bigGoodsStartWeight;
        // submitObj.number = baseInfoForm.channelNumber;
        let submitData = utils.oldObjToNewObj(submitObj, this.baseInfoForm);
        Api.addDeliveryFee(submitData).then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (data.status == "success") {
              this.mainID = data.result.channelId;
              let index = this.activeNameArray.indexOf(this.activeName);
              this.activeName = this.activeNameArray[index + 1];
              this.areaList = [
                {
                  areaCountryName: "",
                  provinceName: "",
                  cityName: "",
                  adcode: "",
                  mileage: "",
                },
              ];
            }
          }
        });
      } else if (this.activeName == "second") {
        if (this.areaList[0].cityName && this.areaList[0].adcode) {
          let index = this.activeNameArray.indexOf(this.activeName);
          this.activeName = this.activeNameArray[index + 1];
          this.priceTable = [];
          this.priceList = [];
          this.priceList.push(...this.priceListArray);
          let priceTableObj = {
            weight: "",
            volume: "",
          };
          this.areaList.forEach((item, index) => {
            //将邮政编码记录
            let title = item.cityName + "（" + item.adcode + "）";
            let priceObj = {
              key: title,
              name: title,
            };
            this.priceList.push(priceObj);
            priceTableObj[title] = "";
          });
          this.priceTable.push(priceTableObj);
        } else {
          ElMessage({
            message: "维护地区不能为空！",
            type: "error",
          });
        }
      } else if (this.activeName == "third") {
        if (this.priceTable.length > 0) {
          if (this.priceTable[0].volume && this.priceTable[0].weight) {
            let index = this.activeNameArray.indexOf(this.activeName);
            this.activeName = this.activeNameArray[index + 1];

            this.deliveryFeeList = [];
            this.deliveryFeeTable = [];
            this.adcodeArray = [];

            this.deliveryFeeList.push(...this.deliveryFeeArray);
            this.areaList.forEach((item) => {
              let title = item.cityName + "（" + item.adcode + "）";
              let deliveryFeeObj = {
                key: title,
                name: title,
                width: "150",
              };
              this.adcodeArray.push(deliveryFeeObj);
              this.deliveryFeeList.push(deliveryFeeObj);
            });
            for (let i = 0; i < this.priceTable.length; i++) {
              let obj = this.priceTable[i];
              // obj.startVolume = "";
              // obj.endVolume = "";
              // obj.startWeight = "";
              // obj.endWeight = "";
              let vIndex = this.priceTable[i].volume.indexOf("-");
              let wIndex = this.priceTable[i].weight.indexOf("-");
              obj.startVolume = parseFloat(
                  this.priceTable[i].volume.slice(0, vIndex)
              );
              obj.endVolume = parseFloat(
                  this.priceTable[i].volume.slice(vIndex + 1)
              );
              obj.startWeight = parseFloat(
                  this.priceTable[i].weight.slice(0, wIndex)
              );
              obj.endWeight = parseFloat(
                  this.priceTable[i].weight.slice(wIndex + 1)
              );
              obj.channelOfferFormulaId = "";
              obj.channelOfferFormulaName = "";
              this.deliveryFeeTable.push(obj);
            }
          } else {
            ElMessage({
              message: "维护价格不能为空！",
              type: "error",
            });
          }
        }
      }
    },
    onPreviousPage() {
      let index = this.activeNameArray.indexOf(this.activeName);
      this.activeName = this.activeNameArray[index - 1];
    },
    getBuMenData() {
      utils.getSelectData("storage_choose_list", 1).then((res) => {
        this.buMenData = res.arr;
      });
    },
    visibleChange(val, type) {
      if (val) {
        if (type == 1) {
          utils.getSelectData("handover_mode", 3).then((res) => {
            this.handoverModeOptions = res.arr;
          });
        } else if (type == 2) {
          utils.getSelectData("", 2).then((res) => {
            this.areaCountryOptions = res.arr;
          });
        } else if (type == 3) {
          utils.getSelectData("formula_down_list", 1).then((res) => {
            this.formulaDownOptions = res.arr;
          });
        } else if (type == 4) {
          utils.getSelectData("formula_big_good_down_list", 1).then((res) => {
            this.formulaBigGoodDownOptions = res.arr;
          });
        } else if (type == 5) {
          utils
              .getSelectData("formula_billing_weight_carry_down_list", 1)
              .then((res) => {
                this.formulaBillingWeightCarryDownOptions = res.arr;
              });
        } else if (type == 6) {
          utils.getSelectData("memberlevel_down_list", 1).then((res) => {
            this.memberlevelDownListOpts = res.arr;
          });
        } else if (type == 7) {
          utils.getSelectData("", 4).then((res) => {
            this.currencyOptions = res.arr;
          });
        } else if (type == 8) {
          utils.getSelectData("channel_offer_formula_down_list", 1).then((res) => {
            this.channelOfferFormulaDownListOptions = res.arr;
          });
        } else if (type == 9) {
          utils.getSelectData("waybill_type", 3).then((res) => {
            this.waybillTypeOptions = res.arr;
          });
        } else if (type == 10) {
          utils.getSelectData("formula_down_list", 1).then((res) => {
            this.formulaBillingWeighOptions = res.arr;
          });
        } else if (type == 11) {
          utils
              .getSelectData("channel_choose_list", 1, [
                {
                  conditonKey: "documentStatus",
                  conditonVal: "channel_v1_delivery_fee:document_status",
                },
              ])
              .then((res) => {
                this.parentChannelOptions = res.arr;
              });
        }
      }
    },
    changePCName(val) {
      this.baseInfoForm.parentChannelName = "";
      this.baseInfoForm.parentId = "";
      this.parentChannelOptions.forEach((item) => {
        if (item.id == val) {
          this.baseInfoForm.parentChannelName = item.channelName;
          this.baseInfoForm.parentId = item.id;
        }
      });
    },
    onSelect(val, arr, type, select) {
      if (type[1]) {
        const obj = utils.jyIDGetContent(arr, select[0], val);
        if (obj) {
          this.baseInfoForm[type[1]] = obj[select[1]];
        }
      }
      this.baseInfoForm[type[0]] = val;
    },
    onSelectDetail(val, arr, type, select, rowIndex) {
      if (type[1]) {
        const obj = utils.jyIDGetContent(arr, select[0], val);
        if (obj) {
          this.$set(this.deliveryFeeTable[rowIndex], type[1], obj[select[1]]);
        }
      }
      this.$set(this.deliveryFeeTable[rowIndex], type[0], val);
    },
    selectCurrency(params) {
      this.currencyOptions.forEach((item) => {
        if (item.cnName === params) {
          this.baseInfoForm.currency = item.cnName;
          this.baseInfoForm.currencyId = item.currencyId;
        }
      });
    },
    onSave() {
      if (this.mainID) {
        let partitionList = [];
        const saveOfferPriceParams = {
          channelId: this.mainID,
          partitionList: [],
        };
        this.deliveryFeeTable.forEach((item, index) => {
          let partitionListObj = {
            channelOfferFormulaId: 0,
            partitionAmountList: [],
            serialNumber: 0,
            unitWeight: "",
            weightSectionList: [],
          };
          partitionListObj.partitionAmountList = this.partitionAmountListHelper(index);
          partitionListObj.serialNumber = index + 1;
          partitionListObj.unitWeight = item.unitWeight + "";
          partitionListObj.channelOfferFormulaId = item.channelOfferFormulaId;
          partitionListObj.weightSectionList = this.weightSectionListHelper(index);
          partitionList.push(partitionListObj);
        });
        saveOfferPriceParams.partitionList = partitionList;
        Api
            .saveOfferPrice(saveOfferPriceParams)
            .then((resdata) => {
              const data = resdata.data;
              if (utils.jyCheckObjectType(data) == "Object") {
                ElMessage({
                  message: data.message,
                  type: data.status,
                });
                setTimeout(() => {
                  if (data.status == "success") {
                    bus.emit("refreshCurrent");
                  }
                }, 300);
              }
            });
      }
    },
    weightSectionListHelper(index) {
      let tempArray = [
        {
          endWeight: "",
          offerWeightType: "",
          startWeight: "",
          weightSegmentName: "",
        },
        {
          endWeight: "",
          offerWeightType: "",
          startWeight: "",
          weightSegmentName: "",
        },
      ];
      let obj = this.deliveryFeeTable[index];
      tempArray[0].endWeight = obj.endWeight;
      tempArray[0].startWeight = obj.startWeight;
      tempArray[0].offerWeightType = "weight:offer_weight_type";
      tempArray[0].weightSegmentName = obj.weight;

      tempArray[1].endWeight = obj.endVolume;
      tempArray[1].startWeight = obj.startVolume;
      tempArray[1].offerWeightType = "volume:offer_weight_type";
      tempArray[1].weightSegmentName = obj.volume;

      return tempArray;
    },
    partitionAmountListHelper(index) {
      let tempArray = [];
      this.adcodeArray.forEach((item) => {
        let tempObj = {
          adcode: "",
          areaCountryName: "",
          cityName: "",
          mileage: "",
          offerAmount: "",
          provinceName: "",
        };
        let frontIndex = item.key.indexOf("（");
        let endIndex = item.key.indexOf("）");
        let deliveryFeeAdcode = item.key.slice(frontIndex + 1, endIndex);

        let arrs = item.key.split("（") || [];
        let deliveryFeeName = arrs.length > 0 ? arrs[0] : "";

        let areaObj = this.areaList.filter((itemA) => {
          return (
              itemA.adcode == deliveryFeeAdcode && itemA.cityName == deliveryFeeName
          );
        });
        tempObj.adcode = areaObj[0].adcode;
        tempObj.areaCountryName = areaObj[0].areaCountryName;
        tempObj.cityName = areaObj[0].cityName;
        tempObj.mileage = areaObj[0].mileage;
        tempObj.offerAmount = this.priceTable[index][item.key];
        tempObj.provinceName = areaObj[0].provinceName;

        tempArray.push(tempObj);
      });
      return tempArray;
    },
    pastingArea(e, item) {
      if (e.clipboardData) {
        e.preventDefault(); //阻止默认粘贴事件
        e.stopPropagation(); //阻止事件冒泡

        const arr = e.clipboardData.getData("Text");
        let rows = arr.split("\r\n"); // 拆成很多行

        for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
          if (rows[rowIndex]) {
            let columns = rows[rowIndex].split("\t"); // 已经按列划分
            let temp = {};
            for (let colIndex = 0; colIndex < columns.length; colIndex++) {
              let keys = Object.keys(this.areaList[0]); // key的名
              if (rowIndex === 0) {
                this.areaList[rowIndex][keys[colIndex]] = columns[colIndex];
              } else {
                temp[keys[colIndex]] = columns[colIndex];
              }
            }
            if (rowIndex !== 0) this.areaList.push(temp);
          }
        }
      }
    },
    onAddAreaInfo() {
      let item = {
        areaCountryName: "",
        provinceName: "",
        cityName: "",
        adcode: "",
        mileage: "",
      };
      this.areaList.push(item);
    },
    onDelAreaList(idx, row) {
      this.areaList.splice(idx, 1);
      // let priceDelIndex = priceList.value.findIndex(item => item.key == row.adcode);
      // priceList.value.splice(priceDelIndex, 1);
      // priceTable.value.forEach((item, index) => {
      //   delete item[row.adcode];
      // });
    },
    pastingPrice(e, item) {
      if (e.clipboardData) {
        e.preventDefault(); //阻止默认粘贴事件
        e.stopPropagation(); //阻止事件冒泡

        const arr = e.clipboardData.getData("Text");
        let rows = arr.split("\r\n"); // 拆成很多行
        let keys = Object.keys(this.priceTable[0]); // key的名
        for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
          if (rows[rowIndex]) {
            let columns = rows[rowIndex].split("\t"); // 已经按列划分
            let temp = {};
            for (let colIndex = 0; colIndex < columns.length; colIndex++) {
              if (rowIndex === 0) {
                this.priceTable[rowIndex][keys[colIndex]] = columns[colIndex];
              } else {
                temp[keys[colIndex]] = columns[colIndex];
              }
            }

            if (rowIndex !== 0) this.priceTable.push(temp);
          }
        }
      }
    },
    onAddPriceInfo() {
      let tempItem = {};
      this.priceList.forEach((item, index) => {
        Object.assign(tempItem, { [item.key]: "" });
      });
      this.priceTable.push(tempItem);
    },
    onDelPriceList(idx, row) {
      this.priceTable.splice(idx, 1);
      // let priceDelIndex = priceList.findIndex(item => item.key == row.adcode);
      // priceList.splice(priceDelIndex, 1);
      // priceTable.value.forEach((item, index) => {
      //   delete item[row.adcode];
      // });
    },
    pastingDeliveryFee(e, item) {
      if (e.clipboardData) {
        e.preventDefault(); //阻止默认粘贴事件
        e.stopPropagation(); //阻止事件冒泡

        const arr = e.clipboardData.getData("Text");

        let rows = arr.split("\r\n"); // 拆成很多行
        let keys = Object.keys(this.deliveryFeeTable[0]); // key的名
        for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
          if (rows[rowIndex]) {
            let columns = rows[rowIndex].split("\t"); // 已经按列划分
            let temp = {};
            for (let colIndex = 0; colIndex < columns.length; colIndex++) {
              if (rowIndex === 0 && this.deliveryFeeTable.length == 0) {
                this.deliveryFeeTable[rowIndex][keys[colIndex]] =
                    columns[colIndex];
              } else {
                temp[keys[colIndex]] = columns[colIndex];
              }
            }

            if (rowIndex !== 0 || this.deliveryFeeTable.length > 0) {
              this.deliveryFeeTable.push(temp);
            }
          }
        }
      }
    },
    onAddDeliveryFeeInfo() {
      let tempItem = {};
      this.deliveryFeeList.forEach((item, index) => {
        Object.assign(tempItem, { [item.key]: "" });
      });
      this.deliveryFeeTable.push(tempItem);
    },
    onDelDeliveryFeeList(idx, row) {
      this.deliveryFeeTable.splice(idx, 1);
      // let priceDelIndex = priceList.findIndex(item => item.key == row.adcode);
      // priceList.splice(priceDelIndex, 1);
      // priceTable.value.forEach((item, index) => {
      //   delete item[row.adcode];
      // });
    },
    offerBaseDetail(id) {
      Api
          .offerBaseDetail({
            channelId: id,
          })
          .then((res) => {
            if (res.status == 200) {
              const data = res.data;
              const result = data.result;
              if (utils.jyCheckObjectType(result) == "Array") {
                let tempForm = result[0];
                let tempArray = [];
                utils.oldObjToNewObj(this.baseInfoForm, tempForm);
                tempForm.dispatchDeptList.forEach((item) => {
                  tempArray.push(item.deptId);
                });
                this.baseInfoForm.dispatchDeptIds = tempArray;
                this.baseInfoForm.number = tempForm.channelNumber;
              }
            }
          });
    },
    blurFn() {
      // 空实现，保留原功能
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/common.scss";

.jy-form-container {
  padding: 0px;
  background: #fff;
  border-radius: 6px;
}

.form-line {
  margin-top: 20px;
  height: 1px;
  background: #ccc;
}

.tag-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.tag-list {
  display: flex;
  margin-top: 15px;

  .tag-span {
    width: 80px;
    height: 33px;
    line-height: 33px;
    text-align: center;
    border: 2px dashed red;
    color: red;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    margin-left: 12px;
  }
}

.jy-main-list {
  height: 100%;
  overflow: hidden;
}

.jy-main-list-table {
  // margin-top: 15px;
  padding: 10px;
  background: #fff;
  height: 100%;
  overflow: hidden;
}

.jy-main-list-topform {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-box {
  display: flex;
}

.operate-list {
  display: flex;

  ::v-deep(.el-button) {
    margin: 0;
    margin-left: 5px;
  }
}

.jy-main-list-top {
  padding: 10px;
  background: #fff;
  height: auto;
  overflow: hidden;

  &.hiddenStyle {
    height: 60px;
  }
}

.iconrotate {
  transform: rotate(180deg);
}

.table-parent-box {
  height: 100%;
}

.table-ground {
  margin-top: 15px;
  height: calc(100% - 67px);
  overflow: hidden;
}

.contentInner {
  width: 100%;
  display: flex;
  height: 100%;

  .leftInner {
    width: 200px;
    margin-right: 16px;
    height: 100%;
  }

  .rightInner {
    flex: 1;
    height: 100%;
  }
}

.formborder {
  border: 1px solid #ebeeff;
  padding: 10px;
  border-radius: 3px;
}
</style>
